import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  requestStart,
  requestFailure,
  fetchTenantsSuccess,
  onboardTenantSuccess,
  updateTenantStatusSuccess
} from './tenantsSlice';
import { iamClient } from 'api/clients';
import { setSRETenant } from 'store/auth';

// Fetch all tenants
export const fetchAllTenantsThunk = createAsyncThunk(
  'tenants/fetchAllTenants',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const { data } = await iamClient.fetchTenants();
      dispatch(fetchTenantsSuccess(data.content));
    } catch (error) {
      dispatch(requestFailure(error.message));
    }
  }
);

// Onboard new tenant
export const onboardTenantThunk = createAsyncThunk(
  'tenants/onboardTenant',
  async (formData, { dispatch }) => {
    dispatch(requestStart());
    try {
      const data = await iamClient.onboardTenant(formData);
      if (data?.success) {
        dispatch(onboardTenantSuccess(formData));
      }

      return data;
    } catch (error) {
      dispatch(requestFailure(error.message));
    }
  }
);

// Activate tenant
export const activateTenantThunk = createAsyncThunk(
  'tenants/activateTenant',
  async (tenantId, { dispatch, rejectWithValue }) => {
    dispatch(requestStart());
    try {
      const data = await iamClient.activateTenant(tenantId);
      dispatch(updateTenantStatusSuccess(data));
      return data;
    } catch (error) {
      dispatch(requestFailure(error.message));
      return rejectWithValue(error.message);
    }
  }
);

// Deactivate tenant
export const deactivateTenantThunk = createAsyncThunk(
  'tenants/deactivateTenant',
  async (tenantId, { dispatch, rejectWithValue }) => {
    dispatch(requestStart());
    try {
      const data = await iamClient.deactivateTenant(tenantId);
      dispatch(updateTenantStatusSuccess(data));
      return data;
    } catch (error) {
      dispatch(requestFailure(error.message));
      return rejectWithValue(error.message);
    }
  }
);

// Get specific tenant data
export const getSpecificTenantData = createAsyncThunk(
  'tenants/getSpecificTenantData',
  async (tenantKey, { dispatch, rejectWithValue }) => {
    dispatch(requestStart());
    try {
      const { data } = await iamClient.getSpecificTenant(tenantKey);
      dispatch(setSRETenant(data));
      return data;
    } catch (error) {
      dispatch(requestFailure(error.message));
      return rejectWithValue(error.message);
    }
  }
);
